import React, { useLayoutEffect, useRef, useState } from 'react';

import Collapsible from '../collapsible/Collapsible';
import FgImages from './graphics/FgImages';
import Backgrounds from './graphics/Background';
import FgVideos from './graphics/FgVideos';
import LowerThirds from './graphics/LowerThirds';

import BrandSettings from './graphics/BrandSettings';

import './GraphicsTools.scss';
import { GraphicsType } from '../../models/layoutClass';

import { StorageService } from '../../services/storage-service';
import { container } from 'tsyringe';
import Tickers from './graphics/Tickers';
import Logos from './graphics/Logos';


export const GraphicsTools = () => {

  const toolsState: any = JSON.parse(localStorage.getItem('toolsState'));
  const graphics = [];
  if (toolsState && toolsState.graphics) {
    for (const gtool of Object.values(GraphicsType)) {
      graphics[gtool] = toolsState.graphics[gtool]?.isOpen || false;
    }
  } else {
    for (const gtool of Object.values(GraphicsType)) {
      graphics[gtool] = false;
    }
  }

  const saveLocalStorage = () => {
    const toolsState = { graphics: {} };
    for(const gtool of Object.values(GraphicsType)) {
      toolsState.graphics[gtool] = {isOpen: graphics[gtool]};
    }
    localStorage.setItem('toolsState', JSON.stringify(toolsState));
  };


  const onOpen = (gtool) => {
    graphics[gtool] = true;
    saveLocalStorage();
  }

  const onClose = (gtool) => {
    graphics[gtool] = false;
    saveLocalStorage();
  }

  const runMenuClose = () => {
    console.log('Graphics tools scrolled');
  }

  return (
    <>

    <Collapsible
      trigger={GraphicsType.BRAND_SETTINGS}
      open={graphics[GraphicsType.BRAND_SETTINGS]}
      onOpen={() => onOpen(GraphicsType.BRAND_SETTINGS)}
      onClose={() => onClose(GraphicsType.BRAND_SETTINGS)}
      explaintips={'Choose the theme that fits your brand. This will set the base style for your on-screen lower thirds, tickers, and name tags, overlays, and on-screen comments.'}
    >
      <BrandSettings></BrandSettings>
    </Collapsible>

    <Collapsible
      trigger={GraphicsType.LOGOS}
      open={graphics[GraphicsType.LOGOS]}
      onOpen={() => onOpen(GraphicsType.LOGOS)}
      onClose={() => onClose(GraphicsType.LOGOS)}
      explaintips={'Add a custom logo to your broadcast to personalize it like a pro. You can add up to four logos and position them on the screen. Recommended size: 500x500. <br/>PNG and JPEG only. Max 1MB.'}
    >
      <Logos></Logos>
    </Collapsible>

    <Collapsible
      trigger={GraphicsType.LOWER_THIRDS}
      open={graphics[GraphicsType.LOWER_THIRDS]}
      onOpen={() => onOpen(GraphicsType.LOWER_THIRDS)}
      onClose={() => onClose(GraphicsType.LOWER_THIRDS)}
      explaintips={'Lower thirds are text banners that appear on the bottom left of the broadcast. You can add primary and secondary text as well as customize the color.'}
    >
      <LowerThirds></LowerThirds>
    </Collapsible>

    <Collapsible
      trigger={GraphicsType.TICKERS}
      open={graphics[GraphicsType.TICKERS]}
      onOpen={() => onOpen(GraphicsType.TICKERS)}
      onClose={() => onClose(GraphicsType.TICKERS)}
      explaintips={'Use a ticker to scroll long text across the bottom of the screen in a thin horizontal scoreboard style. Try adding a background color for extra branding!'}
    >
      <Tickers></Tickers>
    </Collapsible>

    <Collapsible
      trigger={GraphicsType.IMAGES}
      open={graphics[GraphicsType.IMAGES]}
      onOpen={() => onOpen(GraphicsType.IMAGES)}
      onClose={() => onClose(GraphicsType.IMAGES)}
      explaintips={'Add an image to showcase on your broadcast. Supported formats: JPEG, PNG.<br/>Max file size: 20MB.'}
    >
      <FgImages></FgImages>
    </Collapsible>

    <Collapsible
      trigger={GraphicsType.VIDEOS}
      open={graphics[GraphicsType.VIDEOS]}
      onOpen={() => onOpen(GraphicsType.VIDEOS)}
      onClose={() => onClose(GraphicsType.VIDEOS)}
      explaintips={'Upload and play videos on your stream (perfect for intros/outros).Supported formats: MP4, OGV, MOV, WEBM.<br/>Max file size: 300MB '}
    >
      <FgVideos></FgVideos>
    </Collapsible>

    <Collapsible
      trigger={GraphicsType.BACKGROUNDS}
      open={graphics[GraphicsType.BACKGROUNDS]}
      onOpen={() => onOpen(GraphicsType.BACKGROUNDS)}
      onClose={() => onClose(GraphicsType.BACKGROUNDS)}
      explaintips={'Backgrounds appear behind your video streams. Recommended size: 1920x1080px<br/>Max file size: 20MB (3MB for MP4s)'}
    >
      <Backgrounds></Backgrounds>
    </Collapsible>
    </>
  )
}